<script>
  export default {
    name: 'Timer',

    props: {
      endTime: {
        type: Number,
        required: true,
      },
    },

    data: () => ({
      minutes: 0,
      seconds: 0,
      interval: null,
    }),

    mounted() {
      this.startCountdown();
    },

    beforeDestroy() {
      clearInterval(this.interval);
    },

    methods: {
      startCountdown() {
        let now = new Date().getTime();
        let distance = this.endTime - now;

        this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        this.seconds = Math.floor((distance % (1000 * 60)) / 1000);

        this.interval = setInterval(() => {
          now = new Date().getTime();
          distance = this.endTime - now;

          this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          this.seconds = Math.floor((distance % (1000 * 60)) / 1000);

          if (distance < 0) {
            clearInterval(this.interval);
            this.$emit('finish');
          }
        }, 1000);
      },
    },
  };
</script>

<template>
  <div class="timer-wrapper">
    <span
      class="digit"
      v-for="(digit, index) in String(minutes).padStart(2, '0').split('')"
      :key="`first-${digit}-${index}`"
    >
      {{ digit }}
    </span>
    <span>:</span>
    <span
      class="digit"
      v-for="(digit, index) in String(seconds).padStart(2, '0').split('')"
      :key="`second-${digit}-${index}`"
    >
      {{ digit }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
  .bounce-enter-active,
  .bounce-leave-active {
    transition: all 0.5s;
  }

  .bounce-enter,
  .bounce-leave-to {
    opacity: 0;
    transform: scale(0.5);
  }

  .bounce-leave-to {
    position: absolute;
  }

  .timer-wrapper .digit {
    font-variant-numeric: tabular-nums;
  }
</style>
